export const url = 'https://api.coltoncobi.com/'; //url de producción
// export const url = 'http://localhost:4000/';  //url de desarrollo